import React from 'react';
import { Mail, Phone, Info } from 'lucide-react';

const Header = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header className="relative bg-gradient-to-br from-gray-900 via-[#1a2332] to-[#2d3e50] overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 bg-[#33C7A9] rounded-full filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#6A7EC9] rounded-full filter blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>
      
      {/* Subtle grid pattern */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2333C7A9' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}></div>

      <div className="container mx-auto px-6 py-12 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo Section */}
          <div className="flex items-center gap-4 group">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-[#33C7A9] to-[#6A7EC9] rounded-lg opacity-20 blur-xl group-hover:opacity-30 transition-opacity duration-300"></div>
              <img 
                src="/liftgeo-logo.png" 
                alt="LiftGeo" 
                className="h-16 w-auto relative z-10 filter drop-shadow-2xl transition-transform duration-300 group-hover:scale-105"
              />
            </div>
          </div>
          
          {/* Tagline Section */}
          <div className="text-center md:text-right max-w-2xl">
            <div className="flex items-center justify-center md:justify-end gap-3 mb-3">
              <div className="flex gap-2">
                <button
                  onClick={() => scrollToSection('contact-section')}
                  className="p-2 bg-[#33C7A9]/10 rounded-lg backdrop-blur-sm border border-[#33C7A9]/20 hover:bg-[#33C7A9]/20 transition-all duration-300 cursor-pointer group"
                  aria-label="Contact via Email"
                >
                  <Mail className="h-5 w-5 text-[#33C7A9] group-hover:scale-110 transition-transform" />
                </button>
                <button
                  onClick={() => scrollToSection('contact-section')}
                  className="p-2 bg-[#6A7EC9]/10 rounded-lg backdrop-blur-sm border border-[#6A7EC9]/20 hover:bg-[#6A7EC9]/20 transition-all duration-300 cursor-pointer group"
                  aria-label="Contact via Phone"
                >
                  <Phone className="h-5 w-5 text-[#6A7EC9] group-hover:scale-110 transition-transform" />
                </button>
                <button
                  onClick={() => scrollToSection('about-section')}
                  className="p-2 bg-[#33C7A9]/10 rounded-lg backdrop-blur-sm border border-[#33C7A9]/20 hover:bg-[#33C7A9]/20 transition-all duration-300 cursor-pointer group"
                  aria-label="About LiftGeo"
                >
                  <Info className="h-5 w-5 text-[#33C7A9] group-hover:scale-110 transition-transform" />
                </button>
              </div>
            </div>
            <h1 className="text-2xl md:text-3xl font-bold mb-2 bg-gradient-to-r from-white via-gray-100 to-white bg-clip-text text-transparent leading-tight">
              Geospatial Intelligence
            </h1>
            <p className="text-gray-300 text-base md:text-lg leading-relaxed font-light">
              Transforming location data into <span className="text-[#33C7A9] font-semibold">actionable insights</span> through advanced analytics and custom <span className="text-[#6A7EC9] font-semibold">GIS solutions</span>
            </p>
          </div>
        </div>
      </div>
      
      {/* Bottom gradient border */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#6A7EC9] via-[#33C7A9] to-[#6A7EC9]"></div>
    </header>
  );
};

export default Header;